<template>
    <div class="body">
        <div class="bg_1">
            <img class="bg-img" src="@/assets/images1/bg.png" mode="" />
            <div class="div_"></div>
            <div class="body1">
                <div class="item" v-for="(item,index) in data" :key="index">
                    <img class="item1" :style="{height:item.height + 'rem'}" :src="item.url" mode="" />
                    <div class="detail-class" :class="{select: index == 3 || index == 7,select1: index == 6}"
                        @click="toEnterpriseLinkCoreSubmit(index)">
                        查看详情 >>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    beforeCreate() {
        document.querySelector('body').setAttribute('style', 'margin:0;')
    },
    data() {
        return {
            data: [
                {
                    height: 15.7188,
                    url: require("./assets/images1/img1.png"),
                },
                {
                    height: 15.6875,
                    url: require("./assets/images1/img2.png"),
                },
                {
                    height: 15.6875,
                    url: require("./assets/images1/img3.png"),
                },
                {
                    height: 13.4375,
                    url: require("./assets/images1/img4.png"),
                },
                {
                    height: 14.5625,
                    url: require("./assets/images1/img5.png"),
                },
                {
                    height: 14.625,
                    url: require("./assets/images1/img6.png"),
                },
                {
                    height: 18.125,
                    url: require("./assets/images1/img7.png"),
                },
                {
                    height: 14.5,
                    url: require("./assets/images1/img8.png"),
                },
                {
                    height: 15.6875,
                    url: require("./assets/images1/img9.png"),
                },
                {
                    height: 18.125,
                    url: require("./assets/images1/img10.png"),
                }

            ]
        }
    },
    methods: {
        toEnterpriseLinkCoreSubmit(index) {
            console.log(index)
            this.$router.push({ path: "/pathIndex", query: { index: index } })

        },


        butFun() {
            // uni.navigateTo({
            //     url: "@/assets/details2"
            // })
        },
        toDetails(index) {
            // uni.navigateTo({
            //     url: "@/assets/details?index=" + index
            // })
        },
        toDetails1(index) {
            // uni.navigateTo({
            //     url: "@/assets/details1?index=" + index
            // })
        }

    }
}
</script>

<style scoped>
.body {
    width: 100% !important;
    padding-top: 54vh;
    background: rgb(0, 1, 37);
    /* background: rgb(6, 19, 69) !important; */
    /* padding-top: 0px; */
}

.body1 {
    position: relative;
    /* top: .78125rem; */
    box-sizing: border-box;
    z-index: 99;
    width: 100%;
    height: 100%;
    background: rgb(0, 1, 37);
    /* padding: 0 3%; */
    	/* background: rgb(0, 1, 37); */
    /* background: rgb(6, 19, 69) !important; */

}
.bg_1{
    box-sizing: border-box;
     padding: 0 1.375rem;
     background: rgb(0, 1, 37);
}
.bg-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

}

.item {
    position: relative;
    /* padding: 0 1.375rem; */
    margin-top:.9375rem;
    background: rgb(0, 1, 37);

}

.detail-class {
    position: absolute;
    z-index: 100;
    left: 0;
    bottom: 2.1875rem;
    width: 100%;
    height: 2.5rem;
    /* transform: translateX(-50%); */
    font-size: 1.0625rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    text-shadow: 0px 11px 21px rgba(255, 161, 26, 0.21);
    text-align: center;
    line-height: 2.5rem;
}

/* .select {
    position: absolute;
    bottom: 5rem;
} */

/* .select1 {
    position: absolute;
    bottom: 2rem;
} */



.item1 {
    width: 100%;
    position: relative;
    top: -1.875rem;
    /* margin-bottom: 1.875rem; */
    font-size: 0;
}
</style>


// WEBPACK FOOTER //
// src/index.vue